import React from "react";

import { getProducts } from "../../../api/reviews";
import {
    IFormUUID,
    IReviewsBrandID,
    IWebPageURL,
    isoReviewsProductID,
    isoReviewsProductVariantID,
} from "../../../models/nominals";
import { getInteger } from "../../../utils/numbers";
import { useAppSelector, useDispatchers } from "../../reducers";
import { WriteReviewFormMode } from "../constants";
import { defaultState } from "../defaults";
import { Dispatchers } from "../dispatchers";
import { WriteReviewForm } from "../elements/WriteReviewForm";
import { WriteReviewThankYou } from "../elements/WriteReviewThankYou";

interface IProps {
    formUUID: IFormUUID;
    brandID: IReviewsBrandID;
    brand?: string;
    returnURL?: IWebPageURL;
}

export const SingleProductWriteReviewForm = (
    props: IProps,
): React.ReactNode => {
    const dispatchers = useDispatchers(Dispatchers);

    const loadedInitialProducts = useAppSelector((rootState) => {
        const state = rootState.reviews || defaultState;
        return state.data.loadedInitialProducts;
    });

    const productTypeIDs = useAppSelector((rootState) => {
        const state = rootState.reviews || defaultState;
        return state.ui.productTypeIDs;
    });

    const facetValues = useAppSelector((rootState) => {
        const state = rootState.reviews || defaultState;
        return state.ui.facetValues;
    });

    const onReviewSubmit = React.useCallback(() => {
        const reviewModuleTitle = document.querySelector(
            ".write-review-button__container",
        );
        reviewModuleTitle?.scrollIntoView({ behavior: "smooth" });
    }, []);

    React.useEffect(() => {
        dispatchers.registerNewWriteReviewForm(
            props.formUUID,
            WriteReviewFormMode.FORM_OPEN,
        );

        const listProducts = async () => {
            const products = await getProducts(props.brandID);
            dispatchers.setProducts(products);
        };

        void listProducts();
    }, [dispatchers, props.formUUID, props.brandID]);

    if (!loadedInitialProducts) {
        return null;
    }

    const defaultProductTypeID = productTypeIDs[0];
    const defaultProductID = isoReviewsProductID.wrap(
        getInteger(facetValues.product_id, 0),
    );
    const defaultProductVariantID = isoReviewsProductVariantID.wrap(
        getInteger(facetValues.product_variant_id, 0),
    );

    return (
        <div className="write-review-button__container">
            <WriteReviewThankYou formUUID={props.formUUID} />
            <WriteReviewForm
                formUUID={props.formUUID}
                formTitle={"Choose your product"}
                brand={props.brand}
                onReviewSubmit={onReviewSubmit}
                defaultProductTypeID={defaultProductTypeID}
                defaultProductID={defaultProductID}
                defaultProductVariantID={defaultProductVariantID}
                returnURL={props.returnURL}
            />
        </div>
    );
};
